<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
                   [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset"
                   (offset)="getNewTableData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Role</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="rolename"
             placeholder="Enter User Role Name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="roledesc"
             placeholder="Enter User Role Description">
    </div>
    <div class="form-group font-13">
      <label>Type :</label>
      <mat-radio-group (change)="onButtonChange($event)">
        <!--<div *ngFor="let button of radioButton;">-->
        <mat-radio-button value="emp"
                          [checked]="true">Employee
        </mat-radio-button>&nbsp;&nbsp;
        <mat-radio-button value="mngr"
        >Senior Management
        </mat-radio-button>&nbsp;&nbsp;
        <mat-radio-button value="anlyst"
        >Analyst
        </mat-radio-button>&nbsp;&nbsp;
        <!--</div>-->
      </mat-radio-group>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>

